import React, { useState } from 'react';
import './Accordion.css';

const Accordion = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const handleToggle = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const accordionData = [
        {
            title: 'What types of cargo do you handle?',
            content: 'We specialise in general freight, perishable goods, automotive, pharmaceuticals, and more.'
        },
        {
            title: 'Do you offer customs clearance?',
            content: 'Yes, we manage all customs documentation and compliance processes.'
        },
        {
            title: 'How do I track my shipment?',
            content: 'Our real-time tracking system keeps you updated at every step.'
        }
    ];


 

    return (
        <div className="accordion">
            {accordionData.map((item, index) => (
                <div className={`accordion-item ${activeIndex === index ? 'active' : ''}`} key={index}>
                    <button className="accordion-header" onClick={() => handleToggle(index)}>
                        {item.title}
                    </button>
                    <div className="accordion-content">
                        {activeIndex === index && <p>{item.content}</p>}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Accordion;
